import styled from 'styled-components';

export const Form = styled.form`
  position: relative;
`;

export const InputArea = styled.div`
  display: flex;
  margin-top: 30px;

  input[type='number']::-webkit-outer-spin-button,
  input[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const Input = styled.input`
  position: relative;
  display: block;
  width: 100%;
  height: 58px;
  font-size: 14px;
  line-height: 1.2rem;
  background: #fff;
  border: 0.05rem solid #bcc3ce;
  border-radius: 0.1rem;
  color: #3b4351;
  outline: 0;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding: 12px 16px;
  transition: background 0.2s, border 0.2s, box-shadow 0.2s, color 0.2s;

  &:focus {
    border-color: #0d7fe9;
    box-shadow: 0 0 0 0.1rem rgba(13, 127, 233, 0.2);
  }
`;
